<template>
  <!-- eslint-disable max-len-->
  <svg x="0px" y="0px" viewBox="0 0 20 20" width="100%">
    <path
      id="Shape_1_"
      d="M12.8,2.9c-0.5-1.7-0.6-1.9-2-1.9H9.5C8,1,8,1.2,7.5,3l-3,10h2.2l1.3-4.6h4.3l1.3,4.6h2.1L12.8,2.9L12.8,2.9z M8.7,6.5l0.7-2.9C9.6,3,10.1,3,10.1,3s0.5-0.1,0.7,0.6l0.7,2.9L8.7,6.5z"
    ></path>
    <rect
      x="0"
      y="15"
      width="100%"
      height="5"
      stroke-width="1"
      :fill="colour"
    ></rect>
    <path d="M0,15v5h20v-5H0z M19,19H1v-3h18V19z" style="opacity: 0.2"></path>
  </svg>
</template>

<script>
export default {
  props: {
    colour: { type: [String, Object], required: true },
  },
};
</script>
